module.exports = {
      id: "clapboard-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#clapboard",
      toString: function () {
        return this.url;
      }
    }